import React, {useEffect, useCallback, useReducer, useState} from 'react';
import { StyleSheet, Text, View, ScrollView, Button, ActivityIndicator, Alert, KeyboardAvoidingView, Platform, Modal, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector } from 'react-redux'
import BottomLogo from '../components/BottomLogo';
import Card from '../components/Card';
import Input from '../components/Input';
import * as authActions from '../store/authActions';
import * as userActions from '../store/actions';
import { StatusBar } from 'expo-status-bar';

const FORM_INPUT_UPDATE = 'FORM_INPUT_UPDATE';

const formReducer = (state, action) => {
    if (action.type === FORM_INPUT_UPDATE) {
      const updatedValues = {
        ...state.inputValues,
        [action.input]: action.value
      };
      const updatedValidities = {
        ...state.inputValidities,
        [action.input]: action.isValid
      };
      let updatedFormIsValid = true;
      for (const key in updatedValidities) {
        updatedFormIsValid = updatedFormIsValid && updatedValidities[key];
      }
      return {
        formIsValid: updatedFormIsValid,
        inputValidities: updatedValidities,
        inputValues: updatedValues
      };
    }
    return state;
};


const ChangePasswordScreen = props => {
    const userInfo = useSelector(state => state.userdata);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const isWeb = Platform.OS === 'web' && !!userInfo.userData.name;
    const [isLoadingDeactivating, setIsLoadingDeactivating] = useState(false);
    const[webSucces, setWebSucces] = useState(false);
    const dispatch = useDispatch();
    const ref = React.createRef();

    const [formState, dispatchFormState] = useReducer(formReducer, {
        inputValues: {
          newPassword: '',
          repeatPassword: ''
        },
        inputValidities: {
          newPassword: false,
          repeatPassword: false
        },
        formIsValid: false
    });

    const setPasswordHandler = useCallback(async () => {
        if (!formState.formIsValid) {
            Alert.alert('Wrong input', 'Please check the errors in the form.', [
              { text: 'OK'}
            ]);
            return;
          }
        setError(null);
        setIsLoading(true);
        try {
            await dispatch(authActions.setNewPassword(formState.inputValues.newPassword));
            Alert.alert('Succes', 'Your password has changed', [{text: 'Ok' }])
            if(Platform.OS === 'web'){
              setWebSucces(true);
            }
            setIsLoading(false)
        } catch (err) {
          setError(err.message)
          setIsLoading(false)
        }      
    }, [dispatch, formState])

    const deactivateUserHandler = useCallback(async () => {
      setError(null);
      setIsLoadingDeactivating(true);
      const activeAccount = userInfo.userData.activeUser
      try {
        if (activeAccount === 'Y') {
          await dispatch(userActions.deactivateUser('N'));
        } else {
          await dispatch(userActions.deactivateUser('Y'));
        }
          setIsLoadingDeactivating(false)
      } catch (err) {
        setError(err.message)
        setIsLoadingDeactivating(false)
      }      
  }, [dispatch])

    const inputChangeHandler = useCallback((inputIdentifier, inputValue, inputValidity) => {
        dispatchFormState({
          type: FORM_INPUT_UPDATE,
          value: inputValue,
          isValid: inputValidity,
          input: inputIdentifier
        });
      },
      [dispatchFormState]
    );


    return (
            <KeyboardAvoidingView contentContainerStyle={{flex:1}} behavior="padding" style={{flex:1}} keyboardVerticalOffset={-220} >
              <ScrollView>
                <View style={styles.scrollview}>
                <StatusBar style="auto" />
                <View style={styles.titleContainer}><Text style={styles.title}>Change Password</Text></View>
                {error && <Card style={styles.errorContainer}>
                 <Text style={styles.errorText}>{error}</Text>
                </Card>}
                {webSucces &&<View style={{marginTop: 10}}>
                   <Text style={styles.succesText}>Succes! Password changed.</Text>
                </View>}
                <Card style={styles.formContainer}>
                    <Input
                        id="newPassword"
                        label="New Password"
                        errorText="A valid password must have at least 8 characters, one uppercase and lowercase letter, one digit and one special character"
                        keyboardType="default"
                        autoCapitalize="none"
                        returnKeyType="next"
                        textContentType="newPassword"
                        secureTextEntry
                        onInputChange={inputChangeHandler}
                        required
                        minLength={8}
                        isPassword
                        placeholder="Password"
                        onSubmitEditing={() => { ref.current.focus(); }}
                        blurOnSubmit={false}
                    />
                    <Input
                        id="repeatPassword"
                        label="Repeat Password"
                        errorText="Passwords do not match"
                        keyboardType="default"
                        autoCapitalize="none"
                        returnKeyType="go"
                        textContentType="newPassword"
                        secureTextEntry
                        onInputChange={inputChangeHandler}
                        required
                        placeholder="Repeat Password"
                        repeatPassword={formState.inputValues.newPassword}
                        onSubmitEditing={setPasswordHandler}
                        ref={ref}
                    />
                  <View style={{margin: 10}}>
                  {isLoading 
                    ? <ActivityIndicator size='small' color='#404040' />
                    : <Button title="Set Password" color='#404040' onPress={setPasswordHandler} />}
                  </View>
                </Card>
                {isWeb ? 
                <View style={styles.buttonContainer}>
                  <Text>Press the button below to deactivate or reactivate your account. This will stop the system checking on you every month and it will prevent your data from being sent to your mentioned recipient. Only deactivate your account if you are completely sure.</Text>
                  <View style={{width: 200, marginTop: 20}}>
                    {isLoadingDeactivating ? 
                    <ActivityIndicator size='small' color='#404040' /> : 
                    <Button color='#404040' title={userInfo.userData.activeUser === 'Y' ? "Deactivate my account" : "Activate My account"} onPress={deactivateUserHandler} />}
                  </View>
                  <View style={{marginTop: 10}}><Text style={{fontWeight: "bold"}}>Your account is currently: {userInfo.userData.activeUser === 'Y' ? "Active" : "Inactive"}</Text></View>
                </View> : 
                <View style={styles.bottomText}>
                  <Text style={{fontSize: 11, textAlign: 'center'}}>{Platform.OS === 'web' ? 'Your account is not activated until you complete the form' : 'Please visit the FromHereAfter website in case you want to deactivate your account'}</Text>
                  <Text></Text>
                  <Text style={{fontSize: 11, textAlign: 'center'}}>©FromHereAfter 2020</Text>
                  <TouchableOpacity onPress={() => {
                    props.navigation.navigate('About')
                  }} >
                    <Text style={{fontSize: 11, textAlign: 'center', textDecorationLine: "underline"}}>About this app</Text>
                  </TouchableOpacity>
                </View>}
                <BottomLogo />
                </View>
             </ScrollView>
          </KeyboardAvoidingView>
    )
}

ChangePasswordScreen.navigationOptions = {
    headerTitle: 'Change Password'
}

export default ChangePasswordScreen;

const styles = StyleSheet.create({
    scrollview: {
        flex: 1,
        alignItems: 'center',
        padding: 10
    },
    title: {
        fontSize: 32,
        fontWeight: "bold"
    },
    titleContainer: {
        alignItems: 'center',
        marginBottom: 15,
        width: '100%'
    },
    formContainer: {
        width: '85%',
        marginBottom: 10,
        paddingHorizontal: 20,
        maxWidth: 500
    },
    errorContainer: {
      width: '90%',
      marginBottom: 10,
      padding: 5,
      alignItems: 'center',
      maxWidth: 500
    },
    errorText: {
      color: '#d9534f',
      fontSize: 13,
    },
    bottomText: {
      width: '85%',
      marginBottom: 30,
      paddingHorizontal: 20
    },
    buttonContainer: {
      width: 500,
      marginTop: 200,
      paddingHorizontal: 20,
      alignItems: 'center'
    },
    succesText: {
      color: '#0275d8',
      fontSize: 14
    },
});
